import { createContext, useContext } from 'react';

import { useInView } from '#/hooks/useInView';

const BelowFoldContext = createContext<boolean>(true);

/**
 * Returns whether the below-fold homepage section is in (or near) the viewport.
 * Defaults to `true` so components outside this provider (e.g. category pages)
 * fetch immediately.
 */
export function useIsBelowFoldInView(): boolean {
  return useContext(BelowFoldContext);
}

interface HomepageBelowFoldSectionProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wraps the below-fold homepage content. Attaches a single IntersectionObserver
 * and exposes the viewport state to descendants via context.
 */
export function HomepageBelowFoldSection({
  children,
  className,
}: HomepageBelowFoldSectionProps) {
  const { ref, isInView } = useInView({ rootMargin: '250px' });

  return (
    <BelowFoldContext.Provider value={isInView}>
      <div ref={ref} className={className}>
        {children}
      </div>
    </BelowFoldContext.Provider>
  );
}
